import { LocationValidationRules } from './validation';

export const ValidationRules: LocationValidationRules = {
  Default: {
    pages: {
      createUli: {
        uliInformation: {
          loadNumber: { required: true, shouldBeUnique: true },
          pickupPartyAddress: { required: true, disabled: false },
          deliveryPartyAddress: { required: true, disabled: false },
          dangerousGoods: { required: false },
          scheduledRegistrationTime: { required: true },
          type: { required: true },
          numberOfHandlingUnits: { required: true, patternKey: 'onlyNumber' },
          documentNumbers: { required: false },
          weightGross: { required: true, patternKey: 'onlyNumber' },
          loadingMeters: { required: false, patternKey: 'decimalNumber' },
        },

        multiStopInformation: {
          loadNumber: { required: true, shouldBeUnique: true },
          transportOrders: {
            isArray: true,
            elementRules: {
              activityType: { required: true },
              transportOrderNumber: { required: true },
              pickupPartyAddress: { required: true, disabled: false },
              deliveryPartyAddress: { required: true, disabled: false },
              dangerousGoods: { required: false },
              scheduledDepartureTime: { required: true },
              scheduledArrivalTime: { required: true },
              numberOfHandlingUnits: { required: true, patternKey: 'onlyNumber' },
              documentNumbers: { required: false },
              weightGross: { required: true, patternKey: 'onlyNumber' },
              loadingMeters: { required: false, patternKey: 'decimalNumber' },
            },
          },
        },

        truckInformation: {
          dangerousGoods: { required: false },
          loadingTypes: { required: true },
          truckPlateId: { required: false, patternKey: 'vehicleId' },
          truckPlateIdCountryOfOrigin: { required: false },
          trailerPlateId: { required: false, patternKey: 'vehicleId' },
          trailerPlateIdCountryOfOrigin: { required: false },
          truckSize: { required: true },
          emissionStage: { required: false },
        },

        contactData: {
          carrierEmail: { required: false, patternKey: 'email' },
          carrierName: { required: true },
          carrierExtId: { required: true },
          carrierPhone: { required: false },
          rbTransportPlannerEmail: { required: false, patternKey: 'email' },
          rbTransportPlannerPhone: { required: false, patternKey: 'phoneGeneric' },
        },

        driverInformation: {
          firstName: { required: false, patternKey: 'humanName' },
          lastName: { required: false, patternKey: 'humanName' },
          loanerPhoneId: { required: false },
          permitNumber: { required: false },
          permitType: { required: false },
          phoneNumber: { required: false },
          frequentDriverId: { required: false, patternKey: 'onlyNumber' },
        },
      },
    },
  },

  HU: {
    pages: {
      createUli: {
        uliInformation: {
          loadNumber: { required: true, shouldBeUnique: true },
          pickupPartyAddress: { required: true, disabled: false },
          deliveryPartyAddress: { required: true, disabled: false },
          dangerousGoods: { required: false },
          scheduledRegistrationTime: { required: true },
          type: { required: true },
          numberOfHandlingUnits: { required: true, patternKey: 'onlyNumber' },
          documentNumbers: { required: false },
          weightGross: { required: true, patternKey: 'onlyNumber' },
          loadingMeters: { required: false, patternKey: 'decimalNumber' },
        },

        multiStopInformation: {
          loadNumber: { required: true, shouldBeUnique: true },
          transportOrders: {
            isArray: true,
            elementRules: {
              activityType: { required: true },
              transportOrderNumber: { required: true },
              pickupPartyAddress: { required: true, disabled: false },
              deliveryPartyAddress: { required: true, disabled: false },
              dangerousGoods: { required: false },
              scheduledDepartureTime: { required: true },
              scheduledArrivalTime: { required: true },
              numberOfHandlingUnits: { required: true, patternKey: 'onlyNumber' },
              documentNumbers: { required: false },
              weightGross: { required: true, patternKey: 'onlyNumber' },
              loadingMeters: { required: false, patternKey: 'decimalNumber' },
            },
          },
        },

        truckInformation: {
          dangerousGoods: { required: false },
          loadingTypes: { required: true },
          truckPlateId: { required: false, patternKey: 'vehicleId' },
          truckPlateIdCountryOfOrigin: { required: false },
          trailerPlateId: { required: false, patternKey: 'vehicleId' },
          trailerPlateIdCountryOfOrigin: { required: false },
          truckSize: { required: true },
          emissionStage: { required: false },
        },

        contactData: {
          carrierEmail: { required: false, patternKey: 'email' },
          carrierName: { required: true },
          carrierExtId: { required: true },
          carrierPhone: { required: false },
          rbTransportPlannerEmail: { required: false, patternKey: 'email' },
          rbTransportPlannerPhone: { required: false, patternKey: 'phoneGeneric' },
        },

        driverInformation: {
          firstName: { required: false, patternKey: 'humanName' },
          lastName: { required: false, patternKey: 'humanName' },
          loanerPhoneId: { required: false },
          permitNumber: { required: false },
          permitType: { required: false },
          phoneNumber: { required: false },
          frequentDriverId: { required: false, patternKey: 'onlyNumber' },
        },
      },
    },
  },

  CN: {
    pages: {
      createUli: {
        uliInformation: {
          loadNumber: { required: false, shouldBeUnique: true },
          pickupPartyAddress: { required: true, disabled: false },
          deliveryPartyAddress: { required: true, disabled: false },
          dangerousGoods: { required: false },
          scheduledRegistrationTime: { required: true },
          type: { required: true },
          numberOfHandlingUnits: { required: true, patternKey: 'onlyNumber' },
          documentNumbers: { required: false },
          weightGross: { required: false, patternKey: 'onlyNumber' },
          loadingMeters: { required: false, patternKey: 'decimalNumber' },
        },

        multiStopInformation: {
          loadNumber: { required: true, shouldBeUnique: true },
          transportOrders: {
            isArray: true,
            elementRules: {
              activityType: { required: true },
              transportOrderNumber: { required: true },
              pickupPartyAddress: { required: true, disabled: false },
              deliveryPartyAddress: { required: true, disabled: false },
              dangerousGoods: { required: false },
              scheduledDepartureTime: { required: true },
              scheduledArrivalTime: { required: true },
              numberOfHandlingUnits: { required: true, patternKey: 'onlyNumber' },
              documentNumbers: { required: false },
              weightGross: { required: false, patternKey: 'onlyNumber' },
              loadingMeters: { required: false, patternKey: 'decimalNumber' },
            },
          },
        },

        truckInformation: {
          dangerousGoods: { required: false },
          loadingTypes: { required: true },
          truckPlateId: { required: true, patternKey: 'vehicleId' },
          truckPlateIdCountryOfOrigin: { required: false },
          trailerPlateId: { required: false, patternKey: 'vehicleId' },
          trailerPlateIdCountryOfOrigin: { required: false },
          truckSize: { required: true },
          emissionStage: { required: true },
        },

        contactData: {
          carrierEmail: { required: false, patternKey: 'email' },
          carrierName: { required: true },
          carrierExtId: { required: true },
          carrierPhone: { required: false },
          rbTransportPlannerEmail: { required: true, patternKey: 'email' },
          rbTransportPlannerPhone: { required: true, patternKey: 'phoneGeneric' },
        },

        driverInformation: {
          firstName: { required: true, patternKey: 'humanName' },
          lastName: { required: true, patternKey: 'humanName' },
          loanerPhoneId: { required: false },
          permitNumber: { required: true },
          permitType: { required: true },
          phoneNumber: { required: false },
          frequentDriverId: { required: false, patternKey: 'onlyNumber' },
        },
      },
    },
  },
};
